














import { Component, Vue } from 'vue-property-decorator';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

@Component
export default class CookieConsent extends Vue {
  private showBanner = false;

  mounted() {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      this.showBanner = true;
    }
  }

  private acceptCookies() {
    localStorage.setItem('cookie-consent', 'accepted');
    this.showBanner = false;
    this.enableAnalytics();
  }

  private declineCookies() {
    localStorage.setItem('cookie-consent', 'declined');
    this.showBanner = false;
    this.disableAnalytics();
  }

  private enableAnalytics() {
    // Update consent to 'granted'
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }

    // Dynamically load GA script if not already loaded
    if (!document.querySelector('script[src*="googletagmanager.com/gtag"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BZY5CJW9D0';
      document.head.appendChild(script);

      script.onload = () => {
        if (window.gtag) {
          window.gtag('js', new Date());
          window.gtag('config', 'G-BZY5CJW9D0', {
            'anonymize_ip': true
          });
        }
      };
    }
  }

  private disableAnalytics() {
    // Keep consent denied
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  }
}
